/**
 * Builds the "refer a friend" link.
 *
 * The link must point at the site the player is currently using, so it is built from
 * the browser's own origin: localhost keeps localhost, stage keeps stage, prod keeps
 * prod, and any future host works with no code change.
 *
 * This replaces a switch that mapped the API base URL to a hardcoded site URL. Any
 * unmatched API base — localhost included — fell through to the stage default, so
 * players and testers were handed a stage-coin.spinsagacasino.com link no matter
 * where they were.
 */
export const buildReferralLink = (userId) =>
  `${window.location.origin}/?ref=${userId}&campaign=referFriend`;

export default buildReferralLink;
